const NAME = 'DRIP';
const CNameMapping = {
  [NAME]: NAME,
  Drip: NAME,
  drip: NAME,
};

export { NAME, CNameMapping };
